import { render, staticRenderFns } from "./promotionCondition.vue?vue&type=template&id=1add1083&scoped=true&"
import script from "./promotionCondition.vue?vue&type=script&lang=js&"
export * from "./promotionCondition.vue?vue&type=script&lang=js&"
import style0 from "./promotionCondition.vue?vue&type=style&index=0&id=1add1083&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add1083",
  null
  
)

export default component.exports